import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import '../SignUpPage/auth-pages.css';

import captCrest     from '../Assets/CAPT_crest.jpg';
import { FaTelegram } from "react-icons/fa6";

export default function ForgetPasswordPage() {
    const navigate = useNavigate();
    const [telehandle, setTeleHandle] = useState('');
    const [error, setError]           = useState('');
    const [loading, setLoading]       = useState(false);

    // ── original logic, unchanged ──────────────────────────────────────────
    const sendOTP = async () => {
        if (!telehandle) {
            setError('Telegram handle is required.');
            return;
        }
        setError('');
        setLoading(true);
        try {
            await fetch(process.env.REACT_APP_BACKEND_URL + `/auth/whitelist/?username=${telehandle}`)
                .then(res => res.json())
                .then(data => {
                    if (data.exists) {
                        navigate('/otp', {
                            state: { username: telehandle, purpose: 'forgetPassword' },
                        });
                    } else {
                        throw new Error('User is not registered');
                    }
                });
        } catch (err) {
            setError('User is not registered. Redirecting to sign up...');
            setTimeout(() => navigate('/signup'), 1500);
        } finally {
            setLoading(false);
        }
    };
    // ──────────────────────────────────────────────────────────────────────

    return (
        <div className="ap-page">
            <div className="ap-wrap">

                {/* Brand */}
                <div className="ap-brand">
                    <div className="ap-brand-logo">
                        <div className="ap-logo-icon">
                            <img src={captCrest} alt="CAPT Crest" />
                        </div>
                        <span className="ap-wordmark">NEXUS</span>
                    </div>
                    <span className="ap-brand-sub">Captain Portal · By Tech Comm</span>
                </div>

                {/* Card */}
                <div className="ap-card">
                    <div className="ap-card-accent" />
                    <div className="ap-card-header">
                        <h1 className="ap-card-title">Forgot password?</h1>
                        <p className="ap-card-subtitle">We'll send a verification code via Telegram</p>
                    </div>

                    <div className="ap-card-body">

                        <div className="ap-banner ap-banner--info" style={{ marginBottom: 20 }}>
                            <svg viewBox="0 0 16 16" fill="none" width="15" height="15">
                                <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4" />
                                <path d="M8 7v5M8 5v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                            Enter your Telegram handle and we'll send a 6-digit OTP code to verify your identity.
                        </div>

                        <div className="ap-field">
                            <label className="ap-label" htmlFor="fp-handle">Telegram Handle</label>
                            <div className="ap-input-wrap">
                                <FaTelegram className="ap-input-icon" style={{ width: 15, height: 15 }} />
                                <input
                                    id="fp-handle"
                                    className={`ap-input${error ? ' ap-input--error' : ''}`}
                                    type="text"
                                    placeholder="Enter your Telegram handle"
                                    value={telehandle}
                                    autoCapitalize="none"
                                    spellCheck={false}
                                    onChange={e => { setTeleHandle(e.target.value); setError(''); }}
                                    onKeyDown={e => e.key === 'Enter' && sendOTP()}
                                />
                            </div>
                            {error && <span className="ap-error">{error}</span>}
                        </div>

                        <button
                            className="ap-btn-primary"
                            onClick={sendOTP}
                            disabled={loading}
                            style={{ marginTop: 8 }}
                        >
                            {loading ? <span className="ap-spinner" /> : (
                                <>
                                    Send Code
                                    <svg viewBox="0 0 16 16" fill="none" width="14" height="14">
                                        <path d="M2 3L14 8L8 10M2 3L8 10M8 10V14L11 11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </>
                            )}
                        </button>
                    </div>
                </div>

                <p className="ap-below-card">
                    Remember your password?{' '}
                    <button onClick={() => navigate('/')}>Sign in</button>
                </p>
            </div>
        </div>
    );
}
